import { combineReducers } from "redux";
import { loginReducer } from "./auth/login/reducer";
import { contactReducer } from "./contact/reducer";
import { admissionReducer } from "./admission/reducer";
import { galleryReducer } from "./gallery/reducer";
import { noticeReducer } from "./notices/reducer";
import { OneGalleryReducer } from "./gallery/OneGallery/reducer";
import { downloadReducer } from "./download/reducer";
import { popUpReducer } from "./notices/popup/reducer";
import { carouselReducer } from "./dashboard/reducer";
import { alumniReducer } from "./alumni/reducer";
import { detailsReducer } from "./auth/authDetails/reducer";
import { teamReducer } from "./team/reducer";
import { categoryReducer } from "./category/reducer";

export default combineReducers({
  loginReducer,
  contactReducer,
  admissionReducer,
  galleryReducer,
  noticeReducer,
  OneGalleryReducer,
  downloadReducer,
  popUpReducer,
  carouselReducer,
  detailsReducer,
  alumniReducer,
  teamReducer,
  categoryReducer,
});
